import { render } from "./AiPreparation.vue?vue&type=template&id=5fa6c35c&scoped=true"
import script from "./AiPreparation.vue?vue&type=script&lang=js"
export * from "./AiPreparation.vue?vue&type=script&lang=js"

import "./AiPreparation.vue?vue&type=style&index=0&id=5fa6c35c&scoped=true&lang=scss"
import "./AiPreparation.vue?vue&type=style&index=1&id=5fa6c35c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa6c35c"]])

export default __exports__